var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagEnglish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_1388",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4288 0H3.57167C1.59923 0 0.000244141 1.61177 0.000244141 3.6V32.4C0.000244141 34.3882 1.59923 36 3.57167 36H46.4288C48.4013 36 50.0002 34.3882 50.0002 32.4V3.6C50.0002 1.61177 48.4013 0 46.4288 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_1388)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4288 0H3.57167C1.59923 0 0.000244141 1.61177 0.000244141 3.6V32.4C0.000244141 34.3882 1.59923 36 3.57167 36H46.4288C48.4013 36 50.0002 34.3882 50.0002 32.4V3.6C50.0002 1.61177 48.4013 0 46.4288 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_125_1388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 36
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4288 0H3.57167C1.59923 0 0.000244141 1.61177 0.000244141 3.6V32.4C0.000244141 34.3882 1.59923 36 3.57167 36H46.4288C48.4013 36 50.0002 34.3882 50.0002 32.4V3.6C50.0002 1.61177 48.4013 0 46.4288 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_125_1388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 0H6.10352e-05V36H50.0001V0Z",
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.28988 -3.44968L19.0479 11.0579V-2.40008H30.9527V11.0579L52.2904 -3.44968L54.9532 0.529698L38.0829 11.9999H50.0002V23.9999H38.0829L54.9532 35.4702L52.2904 39.4496L30.9527 24.942V38.3999H19.0479V24.942L-2.28988 39.4496L-4.9527 35.4702L11.9176 23.9999H0.000247478V11.9999H11.9176L-4.9527 0.529698L-2.28988 -3.44968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3358 11.3978L55.9524 -3.60016",
    stroke: "#DB1F35",
    strokeWidth: 1.19048,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7372 24.6555L56.0118 38.4306",
    stroke: "#DB1F35",
    strokeWidth: 1.19048,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2957 11.3589L-6.85254 -3.00772",
    stroke: "#DB1F35",
    strokeWidth: 1.19048,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5895 24.4889L-6.85254 40.159",
    stroke: "#DB1F35",
    strokeWidth: 1.19048,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10352e-05 21.6H21.4286V36H28.5715V21.6H50.0001V14.4H28.5715V0H21.4286V14.4H6.10352e-05V21.6Z",
    fill: "#E6273E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEnglish);
export default __webpack_public_path__ + "static/media/flag-english.19e5d269b83365e0120a10acbbd212b9.svg";
export { ForwardRef as ReactComponent };